import { TransactionStateLabel } from '../TransactionStateLabel';
import { Transaction } from '../../../../models';
import { SidebarRow } from '../../../../components/sidebar/SidebarRow';
import { ServiceRepresentation } from '../../../../components/dataRepresentation/ServiceRepresentation';

type TransactionSummaryTableProps = {
  transaction: Transaction;
};

export const TransactionSummaryTable = ({
  transaction,
}: TransactionSummaryTableProps) => {
  const vehicle = transaction.vehicle;

  if (!transaction || !vehicle) {
    return <></>;
  }

  return (
    <table
      className="table table-condensed"
      data-testid={'transactions-sidebar-summary'}
    >
      <colgroup>
        <col style={{ width: 150 }} />
        <col />
      </colgroup>
      <tbody>
        <SidebarRow label="common.transaction.state">
          <TransactionStateLabel state={transaction.state} />
        </SidebarRow>
        <SidebarRow label="common.vehicle.vin">{vehicle.vin}</SidebarRow>
        <SidebarRow
          label="common.vehicle.licensePlate"
          show={!!vehicle.licensePlate}
        >
          {vehicle.licensePlate}
        </SidebarRow>
        <SidebarRow
          label="common.transaction.mileage"
          show={!!transaction.vehicleDetails.mileage}
        >
          {transaction.vehicleDetails.mileage}
        </SidebarRow>
        <SidebarRow label="common.serviceType">
          <ServiceRepresentation serviceType={transaction.serviceType} />
        </SidebarRow>
      </tbody>
    </table>
  );
};
